// ALMOST COPY-PASTE FROM nv.d3.js (nvd3/src/tooltip.js)

// Format function for the tooltip values column.
// d is value,
// i is series index
// p is point containing the value
var valueFormatter = function(d, i, p) {
    return d;
};

var headerEnabled = true;

// Format function for the tooltip header value.
var utils = require('amt_admin/utils');
var headerFormatter = utils.transform_to_date_if_timestamp;

var keyFormatter = function(d, i) {
    return d;
};

// By default, the tooltip model renders a beautiful table inside a DIV, returned as HTML
// You can override this function if a custom tooltip is desired. For instance, you could directly manipulate
// the DOM by accessing elem and returning false.
var contentGenerator = function(d, elem, hideZeroValues) {
    if (d === null) {
        return '';
    }

    var table = d3.select(document.createElement("table"));
    if (headerEnabled) {
        var theadEnter = table.selectAll("thead")
            .data([d])
            .enter().append("thead");

        theadEnter.append("tr")
            .append("td")
            .attr("colspan", 3)
            .append("strong")
            .classed("x-value", true)
            .html(headerFormatter(d.value));
    }

    var tbodyEnter = table.selectAll("tbody")
        .data([d])
        .enter().append("tbody");

    var trowEnter = tbodyEnter.selectAll("tr")
            .data(function(p) {
                return hideZeroValues ? p.series.filter(x => x.data.y !== 0) : p.series;
            })
            .enter()
            .append("tr")
            .classed("highlight", function(p) { return p.highlight});

    trowEnter.append("td")
        .classed("legend-color-guide",true)
        .append("div")
        .style("background-color", function(p) { return p.color});

    trowEnter.append("td")
        .classed("key",true)
        .classed("total",function(p) { return !!p.total})
        .html(function(p, i) { return keyFormatter(p.key, i)});

    trowEnter.append("td")
        .classed("value",true)
        .html(function(p, i) { return valueFormatter(p.value, i, p) });

    trowEnter.filter(function (p,i) { return p.percent !== undefined }).append("td")
        .classed("percent", true)
        .html(function(p, i) { return "(" + d3.format('%')(p.percent) + ")" });

    trowEnter.selectAll("td").each(function(p) {
        if (p.highlight) {
            var opacityScale = d3.scale.linear().domain([0,1]).range(["#fff",p.color]);
            var opacity = 0.6;
            d3.select(this)
                .style("border-bottom-color", opacityScale(opacity))
                .style("border-top-color", opacityScale(opacity))
            ;
        }
    });

    var html = table.node().outerHTML;
    if (d.footer !== undefined)
        html += "<div class='footer'>" + d.footer + "</div>";
    return html;

};

export default contentGenerator;
